import React from 'react';

const YoutubeEmbed = ({ embedId, autoplay = true }) => (
    <div className="video-responsive">
        <iframe
            width="853"
            height="480"
            src={`https://www.youtube.com/embed/${embedId}?rel=0&showinfo=0&mute=1&loop=1` + (autoplay ? '&playsinline=1&autoplay=1' : '')}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
            referrerPolicy="strict-origin-when-cross-origin"
        />
    </div>
);
export default YoutubeEmbed;
